import { Component, Host, h, Prop } from '@stencil/core';
import { AnchorInterface, generateAnchorAttributes, openURL } from '../../utils/elements-interface';

/**
 * @slot - Designed to receive anchored content.
 */
@Component({
  tag: 'sy-router-link',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class RouterLink implements AnchorInterface {
  /**
     HTML <a> download attribute
    */
  @Prop() download: string | undefined;

  /**
   * HTML <a> href attribute
   */
  @Prop() href: string | undefined;

  /**
   * HTML <a> rel attribute
   */
  @Prop() rel: string | undefined;

  /**
   * HTML <a> target attribute
   */
  @Prop() target: '_blank' | '_self' | '_parent' | '_top' = '_blank';

  /**
   * Defines whether the link should be stretched
   */
  @Prop({ reflect: true }) stretchedLink = false;

  private onClick = (ev: Event) => {
    openURL(this.href, ev);
  };

  render() {
    const AnchorTag = this.stretchedLink ? 'sy-stretched-link' : 'a';

    return (
      <Host onClick={this.onClick}>
        <AnchorTag {...generateAnchorAttributes(this)}>
          <slot></slot>
        </AnchorTag>
      </Host>
    );
  }
}
